import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as DiscordIcon } from '@pkg/assets/icons/v2/social/discord.svg';
import { ReactComponent as InstagramIcon } from '@pkg/assets/icons/v2/social/instagram.svg';
import { ReactComponent as TikTokIcon } from '@pkg/assets/icons/v2/social/tiktok.svg';
import { ReactComponent as TwitterIcon } from '@pkg/assets/icons/v2/social/twitter.svg';
import { ReactComponent as YatLogoFull } from '@pkg/assets/logotypes/full.svg';
import { ExternalLink } from '@pkg/components';

import config from '@app/config';

import './Footer.scss';

const Footer = () => {
    const { t } = useTranslation(['common', 'words', 'translation']);
    const { jobsLink, privacyLink, supportLink, termsLink, licenseLink, disclosureLink, socialMedia, yativerseLink } =
        config;
    const year = new Date().getFullYear();

    return (
        <div className="yat-dashboard-footer">
            <div className="yat-dashboard-footer__top">
                <YatLogoFull className="yat-dashboard-footer__logo" />
                <nav className="yat-dashboard-footer__social">
                    <ExternalLink
                        className="yat-dashboard-footer__social__link"
                        href={socialMedia.twitter}
                        aria-label={t('common:twitter')}
                    >
                        <TwitterIcon className="yat-dashboard-footer__social__icon" />
                    </ExternalLink>
                    <ExternalLink
                        className="yat-dashboard-footer__social__link"
                        href={socialMedia.discord}
                        aria-label={t('common:discord')}
                    >
                        <DiscordIcon className="yat-dashboard-footer__social__icon" />
                    </ExternalLink>
                    <ExternalLink
                        className="yat-dashboard-footer__social__link"
                        href={socialMedia.tiktok}
                        aria-label={t('common:tiktok')}
                    >
                        <TikTokIcon className="yat-dashboard-footer__social__icon" />
                    </ExternalLink>
                    <ExternalLink
                        className="yat-dashboard-footer__social__link"
                        href={socialMedia.instagram}
                        aria-label={t('common:instagram')}
                    >
                        <InstagramIcon className="yat-dashboard-footer__social__icon" />
                    </ExternalLink>
                </nav>
            </div>
            <div className="yat-dashboard-footer__bottom">
                <nav className="yat-dashboard-footer__yat-links">
                    <ExternalLink href={yativerseLink}>{t('yativerse')}</ExternalLink>
                    <ExternalLink href={supportLink}>{t('words:help')}</ExternalLink>
                    <ExternalLink href={jobsLink}>{t('words:careers')}</ExternalLink>
                </nav>
                <nav className="yat-dashboard-footer__legal">
                    <ExternalLink href={termsLink}>{t('terms_link_terms')}</ExternalLink>
                    <ExternalLink href={privacyLink}>{t('terms_link_privacy_agreement')}</ExternalLink>
                    <ExternalLink href={disclosureLink}>{t('terms_link_disclosure')}</ExternalLink>
                    <ExternalLink href={licenseLink}>{t('terms_link_nft_license')}</ExternalLink>
                    <span>
                        &copy; {year} {t('translation:yat')}
                    </span>
                </nav>
            </div>
        </div>
    );
};

export default Footer;
